export const CODE_NOT_LOGGED_IN_NEXT = 1401;

export const CODE_NOT_LOGGED_IN_VISMA = 1402;
